import { action, makeObservable, observable, runInAction } from "mobx";
import api from "../../api";
import { Category } from "./Category";

class CategoriesStore {
  categories: Category[] = [];
  category?: Category = undefined;

  constructor() {
    makeObservable(this, {
      categories: observable,
      category: observable,
      getCategories: action.bound,
      getCategory: action.bound,
      updateCategoryProperty: action.bound,
      createCategory: action.bound,
      deleteCategory: action.bound,
      resetCategory: action.bound,
      starCategory: action.bound,
      uploadProductTypeImage: action.bound
    });
  }

  async getCategories(applicationId: string) {
    try {
      const info = await api.categories.getCategories(applicationId);
      const categories = info.map(Category.convertFrom);

      runInAction(() => {
        this.categories = categories;
      });
    } catch (e) {
      console.error(e);
    }
  }

  async getCategory(applicationId: string, categoryCode: string) {
    try {
      const info = await api.categories.getCategory(applicationId, categoryCode);
      const category = Category.convertFrom(info);

      runInAction(() => {
        this.category = category;
      });
    } catch (e) {
      console.error(e);
    }
  }

  async updateCategoryProperty(
    applicationId: string,
    categoryCode: string,
    fieldId: string,
    newValue: string
  ): Promise<boolean> {
    try {
      return await api.categories.updateCategoryProperty(applicationId, categoryCode, fieldId, newValue);
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async createCategory(applicationId: string, productType: string): Promise<string> {
    try {
      return await api.categories.createCategory(applicationId, productType);
    } catch (e) {
      console.error(e);
      return "";
    }
  }

  async deleteCategory(applicationId: string, categoryCode: string): Promise<boolean> {
    try {
      return await api.categories.deleteCategory(applicationId, categoryCode);
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async resetCategory(applicationId: string, categoryCode: string): Promise<boolean> {
    try {
      return await api.categories.resetCategory(applicationId, categoryCode);
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async starCategory(applicationId: string, categoryCode: string): Promise<boolean> {
    try {
      return await api.categories.starCategory(applicationId, categoryCode);
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async uploadProductTypeImage(applicationId: string, categoryName: string, selectedFile: File): Promise<boolean> {
    try {
      return await api.categories.uploadProductTypeImage(applicationId, categoryName, selectedFile);
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}

export default CategoriesStore;